export default "__VITE_ASSET__ChKlQcRl__"